import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from '@mui/material';
import DialogContentText from '@mui/material/DialogContentText';
import {addNewTeam} from "../../asyncActions/addNewTeam";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {store} from "../../mobx/store";
import { observer } from "mobx-react";

export interface IDialogButtonRegistrationProps {
    streamName: string;
}

const DialogButtonRegistration: React.FC<IDialogButtonRegistrationProps> = observer(({ streamName }) => {
    const [open, setOpen] = useState(false); // Состояние для контроля открытого состояния диалога


    const [userName, setUserName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [telegram, setTelegram] = useState<string>("");
    const [itAges, setItAges] = useState<number>(0.0);
    const [commandName, setCommandName] = useState<string>("");
    const [projectAbout, setProjectAbout] = useState<string>("");



    const handleUserName = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value !== undefined){setUserName(e.target.value)}
    }

    const handleEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value !== undefined){setEmail(e.target.value)}
    }

    const handleTelegram = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value !== undefined){setTelegram(e.target.value)}
    }

    const handleITAges = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        if ((inputValue !== undefined)&&((inputValue === '')||(/^\d*\.?\d*$/.test(inputValue)))){setItAges(Number(inputValue))}
    }

    const handleProjectAbout = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value !== undefined){setProjectAbout(e.target.value)}
    }


    const handleCommandName = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value !== undefined){setCommandName(e.target.value)}
    }

    const handleClickOpen = () => {
        setOpen(true); // Открыть диалог
    };

    const handleClose = () => {
        setOpen(false); // Закрыть диалог
    };

    const handleRegistrationClick = async () => {
        await addNewTeam(userName, email, telegram, itAges, commandName, streamName, projectAbout, store.referer)
        setUserName("");
        setEmail("");
        setTelegram("");
        setItAges(0.0);
        setCommandName("");
        setProjectAbout("");
        setOpen(false); // Закрыть диалог
        toast.success('Вы успешно зарегистрировали команду ' + commandName, {
            autoClose: 10000,  // Уведомление закроется через 30 секунд
            position: "top-right"
        });
    }

    return(
        <>
            <Button
                variant="contained"    // Использует стиль заполненной кнопки
                size="large"           // Увеличивает размер кнопки
                onClick={handleClickOpen}
                sx={{
                    width: '200px',      // Задаем ширину кнопки
                    height: '60px',      // Задаем высоту кнопки
                    fontSize: '1.2rem',  // Увеличиваем размер шрифта
                    borderRadius: '8px', // Скругляем углы
                }}
            >
                Участвовать
            </Button>
            <ToastContainer />

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Регистрация команды</DialogTitle>
                <DialogContent>
                <DialogContentText>
                    Заполните все поля
                </DialogContentText>
                    <TextField
                        required
                        margin="dense"
                        label="Название команды"
                        value={commandName}
                        fullWidth
                        variant="standard"
                        onChange={handleCommandName}
                    />

                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        label="Полное имя капитана команды"
                        value={userName}
                        fullWidth
                        variant="standard"
                        onChange={handleUserName}
                    />

                    <TextField
                        required
                        margin="dense"
                        label="email"
                        value={email}
                        type="email"
                        fullWidth
                        variant="standard"
                        onChange={handleEmail}
                    />

                    <TextField
                        required
                        margin="dense"
                        label="Telegram"
                        value={telegram}
                        fullWidth
                        variant="standard"
                        onChange={handleTelegram}
                    />

                    <TextField
                        required
                        margin="dense"
                        label="Сколько лет в IT?"
                        value={itAges}
                        fullWidth
                        variant="standard"
                        onChange={handleITAges}
                        inputProps={{
                            inputMode: 'decimal', // Устанавливаем подходящую клавиатуру для ввода чисел
                            pattern: '[0-9]*([,.][0-9]*)?', // Позволяет вводить числа с точкой или запятой
                        }}
                    />

                    <TextField
                        required
                        margin="dense"
                        label="Краткое описание проекта"
                        value={projectAbout}
                        fullWidth
                        variant="standard"
                        onChange={handleProjectAbout}
                        multiline
                        rows={4}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Отмена
                    </Button>
                    <Button onClick={handleRegistrationClick} color="primary">
                        Зарегистрироваться
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
})

export default DialogButtonRegistration;